export function pickTableError(
  index: number,
  fieldName: string,
  errors: Record<string, any>
): string | undefined {
  const errorPath = `[${index}].${fieldName}`;

  return errors[errorPath];
}
